import { createSlice } from "@reduxjs/toolkit"
import { decryptStudents } from "../utils/fieldDecryption"

const dt = new Date()
const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
const day = dt.getUTCDate();
const month = String(dt.getMonth() + 1).padStart(2, '0');
const year = dt.getFullYear();
const date = year + "-" + month + "-" + day;

let data = []

if (localStorage.getItem("student") !== null && localStorage.getItem("student") !== undefined && localStorage.getItem("student") !== "") {
    data = [JSON.parse(localStorage.getItem("student"))]
}

const Insider = createSlice({
    name: "todos",
    initialState: data,
    reducers: {
        getdata: (state, action) => {
            const students = action.payload.data || [];
            // Decrypt encrypted fields before storing in Redux
            return decryptStudents(students);
        },

        logout_: (state, action) => {
            localStorage.clear()
            state = []
            return state
        },

        updatestudentdata: (state, action) => {
            const students = action.payload.data || [];
            // Decrypt encrypted fields before storing in Redux
            return decryptStudents(students);
        },

        updateStudent: (state, action) => {
            const { studentId, updatedData } = action.payload;
            const studentIndex = state.findIndex(student => student._id === studentId);
            if (studentIndex !== -1) {
                state[studentIndex] = { ...state[studentIndex], ...updatedData };
            }
            return state;
        },

        deleteStudent: (state, action) => {
            const studentId = action.payload;
            return state.filter(student => student._id !== studentId);
        },

        updateCanteenPayments: (state, action) => {
            const { paymentData } = action.payload;
            
            paymentData.forEach(payment => {
                const studentIndex = state.findIndex(student => student._id === payment.id);
                const entry = payment?.data?.canteen;
                const entryDate = entry?.date;
                if (studentIndex === -1 || !entryDate) return;

                if (!state[studentIndex].canteen) {
                    state[studentIndex].canteen = [];
                }
                const existingPaymentIndex = state[studentIndex].canteen.findIndex(
                    (canteenEntry) => canteenEntry.date === entryDate
                );
                if (existingPaymentIndex !== -1) {
                    state[studentIndex].canteen[existingPaymentIndex] = entry;
                } else {
                    state[studentIndex].canteen.push(entry);
                }
            });
            return state;
        },

        // Update single student attendance - Efficient approach
        updateStudentAttendance: (state, action) => {
            const { studentId, attendanceData, term, date } = action.payload;
            const studentIndex = state.findIndex(student => student._id === studentId);
            
            if (studentIndex !== -1) {
                if (!state[studentIndex].attendance) {
                    state[studentIndex].attendance = {};
                }
                if (!state[studentIndex].attendance[term]) {
                    state[studentIndex].attendance[term] = [];
                }

                const dateKey = (() => {
                    const raw = date ?? attendanceData?.date;
                    if (raw == null || raw === '') return '';
                    if (typeof raw === 'string') {
                        const head = raw.match(/^(\d{4}-\d{2}-\d{2})/);
                        if (head) return head[1];
                    }
                    const d = new Date(raw);
                    if (Number.isNaN(d.getTime())) return String(raw);
                    return d.toISOString().split('T')[0];
                })();

                const termList = state[studentIndex].attendance[term];
                const existingIndex = termList.findIndex((att) => {
                    const ad = att?.date;
                    if (ad == null) return false;
                    if (typeof ad === 'string') {
                        const head = ad.match(/^(\d{4}-\d{2}-\d{2})/);
                        return (head ? head[1] : ad) === dateKey;
                    }
                    return false;
                });

                const record = { ...attendanceData, date: dateKey || attendanceData.date };

                if (existingIndex !== -1) {
                    state[studentIndex].attendance[term][existingIndex] = record;
                } else {
                    state[studentIndex].attendance[term].push(record);
                }
            }
            return state;
        },

        // Update multiple students attendance - Efficient approach
        bulkUpdateStudentAttendance: (state, action) => {
            const { attendanceUpdates } = action.payload;
            
            attendanceUpdates.forEach(update => {
                const { studentId, attendanceData, term, date } = update;
                const studentIndex = state.findIndex(student => student._id === studentId);
                
                if (studentIndex !== -1) {
                    // Initialize attendance structure if it doesn't exist
                    if (!state[studentIndex].attendance) {
                        state[studentIndex].attendance = {};
                    }
                    
                    // Initialize term structure if it doesn't exist
                    if (!state[studentIndex].attendance[term]) {
                        state[studentIndex].attendance[term] = [];
                    }
                    
                    const dateKey = (() => {
                        const raw = date ?? attendanceData?.date;
                        if (raw == null || raw === '') return '';
                        if (typeof raw === 'string') {
                            const head = raw.match(/^(\d{4}-\d{2}-\d{2})/);
                            if (head) return head[1];
                        }
                        const d = new Date(raw);
                        if (Number.isNaN(d.getTime())) return String(raw);
                        return d.toISOString().split('T')[0];
                    })();

                    const termList = state[studentIndex].attendance[term];
                    const existingIndex = termList.findIndex((att) => {
                        const ad = att?.date;
                        if (ad == null) return false;
                        if (typeof ad === 'string') {
                            const head = ad.match(/^(\d{4}-\d{2}-\d{2})/);
                            return (head ? head[1] : ad) === dateKey;
                        }
                        return false;
                    });

                    const record = { ...attendanceData, date: dateKey || attendanceData.date };

                    if (existingIndex !== -1) {
                        state[studentIndex].attendance[term][existingIndex] = record;
                    } else {
                        state[studentIndex].attendance[term].push(record);
                    }
                }
            });
            return state;
        }
    }
})

export const { 
    logout_, 
    updatestudentdata, 
    login, 
    getdata, 
    updateStudent, 
    deleteStudent, 
    updateCanteenPayments,
    updateStudentAttendance,
    bulkUpdateStudentAttendance
} = Insider.actions;
export default Insider.reducer;
